import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Box, Collapse, Grid, Modal } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import ViewAndFilterButton from "../components/ViewAndFilterButton";
import ViewOption from "../components/ViewOption";
import Loader from "../components/general/Loader";
import LoadingBackdrop from "../components/general/LoadingBackdrop";
import NoData from "../components/general/NoData";
import NunitoText from "../components/general/NunitoText";
import ReusableButton from "../components/general/ReusableButton";
import ReusableTextField from "../components/general/ReusableTextField";
import AddTaskToCompetitionAndCollectionModal from "../components/modal/AddTaskToCompetitionAndCollectionModal";
import DeleteModal from "../components/modal/DeleteModal";
import HeavyTable from "../components/table/HeavyTable";
import { showWarningSwal } from "../functions/alert";
import { deleteTask } from "../functions/deleteData";
import {
  buildQueryString,
  cancelAction,
  changeViewOptions,
  controlFilter,
  controlView,
  makeSureIsArray,
} from "../functions/general";
import { enhancedTasks } from "../functions/getData";
import { showNotification } from "../functions/snackbar";

import { useSnackbar } from "notistack";
import FilterWrapper from "../components/general/FiltersWrapper";
import DuplicateTask from "../components/modal/DuplicateTask";
import { duplicatetasks } from "../functions/postData";

const taskHeader = [
  { id: "identifier", label: "Task Identifier" },
  { id: "title", label: "Task Title" },
  { id: "status", label: "Status" },
  { id: "description", label: "Description" },
  { id: "languages", label: "No. of Language(s)" },
  { id: "domain", label: "Domain" },
  { id: "tags", label: "Tags" },
  { id: "grade_difficulty", label: "Recommended Difficulty" },
  { id: "answer_type", label: "Answer Type" },
  { id: "answer_structure", label: "Answer Structure" },
  { id: "answer_sorting", label: "Display Order" },
  { id: "task_answers", label: "No. of Correct Answers" },
  // { id: 'collections', label: 'Collections' },
  // { id: 'competitions', label: 'Competitions' },
  { id: "created_by", label: "Created By" },
  { id: "last_modified_by", label: "Last Modified By" },
];

export default function EnhancedTasks() {
  document.title = "Task";
  const isMounted = useRef(false);
  const [header, setHeader] = useState(taskHeader);
  const [taskTable, setTaskTable] = useState();
  const [viewOptions, setViewOptions] = useState([
    { label: "No. of Langauge(s)", state: true, key: "task_content" },
    { label: "Domain", state: true, key: "domain" },
    { label: "Tags", state: true, key: "tags" },
    {
      label: "Recommended Difficulty",
      state: true,
      key: "recommended_difficulty",
    },
    { label: "Answer Type", state: true, key: "answer_type" },
    { label: "Answer Structure", state: true, key: "answer_structure" },
    { label: "Display Order", state: true, key: "display_order" },
    { label: "No. of answers", state: true, key: "answers" },
    { label: "Collections", state: true, key: "collections" },
    { label: "Competitions", state: true, key: "competitions" },
    { label: "Created By", state: true, key: "created_by_username" },
    { label: "Last Modified By", state: true, key: "modified_by_username" },
    {
      label: "Last Verified By(Last 5)",
      state: true,
      key: "verified_by_username",
    },
    { label: "Status", state: true, key: "status" },
  ]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingTable, setLoadingTable] = useState(false);
  const [viewing, setViewing] = useState(false);
  const [filtering, setFiltering] = useState(false);
  const [id, setId] = useState("");
  const [selected, setSelected] = useState([]);
  const [selecting, setSelecting] = useState([]);
  const [onDelete, setOnDelete] = useState(false);
  const [onAddTask, setOnAddTask] = useState(false);
  const [onDup, setOnDups] = useState(false);
  const [onAssignTaskPermission, setOnAssignTaskPermission] = useState(false);
  const [sortAbleColumns, setSortableColumns] = useState([]);

  // Consolidated query parameters state
  const [queryParams, setQueryParams] = useState({
    limits: 10,
    page: 1,
    search: "",
    languages: "",
    domains: "",
    tags: "",
    status: "",
    orderBy: "",
    orderDirection: "",
    collection_id: "",
  });

  const handleView = () => controlView(viewing, setViewing, setFiltering);
  const handleFilter = () => controlFilter(filtering, setFiltering, setViewing);
  const cancelDelete = () => cancelAction(setOnDelete, setId);
  const cancelAddTask = () => cancelAction(setOnAddTask);
  const cancelAssignTaskPermission = () =>
    cancelAction(setOnAssignTaskPermission);
  const canceldubs = () => cancelAction(setOnDups);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const afterFunction = (cancel, data) => {
    if ([200, 201].includes(data.status)) {
      if (controller.current) {
        setSelected([]);
        setSelecting([]);
        setLoading(true);

        const queryString = buildQueryString(queryParams);
        enhancedTasks(queryString, controller.current.signal).then((res) => {
          const formattedData = res.data.map((obj) => ({
            ...obj,
            title: obj?.task_contents[0]?.task_title,
          }));
          res.data = formattedData;
          setTaskTable(res);
          setSortableColumns(res?.sortable_columns);
          setLoading(false);
        });
      }
      cancel();
      showNotification("success", data.message, enqueueSnackbar, closeSnackbar);
    }
  };
  const isFirstRender = useRef(true);

  const updateQueryParams = (updates) => {
    setQueryParams((prev) => ({
      ...prev,
      ...updates,
    }));
  };
  console.log(taskTable);
  const resetQueryParams = () => {
    setQueryParams({
      limits: 10,
      page: 1,
      search: "",
      languages: "",
      domains: "",
      tags: "",
      status: "",
      orderBy: "",
      orderDirection: "",
      collection_id: "",
    });
  };

  const adjustEndpoint = (endpoint, value) => {
    const currentParams = { ...queryParams };

    // Remove the current filter value if it's being changed
    if (value !== currentParams.languages && currentParams.languages) {
      endpoint += `&languages=${currentParams.languages}`;
    }
    if (value !== currentParams.domains && currentParams.domains) {
      endpoint += `&domains=${currentParams.domains}`;
    }
    if (value !== currentParams.tags && currentParams.tags) {
      endpoint += `&tags=${currentParams.tags}`;
    }
    if (value !== currentParams.status && currentParams.status) {
      endpoint += `&status=${currentParams.status}`;
    }

    return endpoint;
  };

  const filters = [
    {
      label: "Language",
      endpoint: "tasks/list?get_filter=languages",
      value: queryParams.languages,
      onChange: (value) => updateQueryParams({ languages: value }),
      key: "languages",
      setValue: (value) => updateQueryParams({ languages: value }),
    },
    {
      label: "Domain",
      endpoint: "tasks/list?get_filter=domains",
      value: queryParams.domains,
      onChange: (value) => updateQueryParams({ domains: value }),
      key: "domains",
      setValue: (value) => updateQueryParams({ domains: value }),
    },
    {
      label: "Tag",
      endpoint: "tasks/list?get_filter=tags",
      value: queryParams.tags,
      onChange: (value) => updateQueryParams({ tags: value }),
      key: "tags",
      setValue: (value) => updateQueryParams({ tags: value }),
    },
    {
      label: "Status",
      endpoint: "tasks/list?get_filter=status",
      value: queryParams.status,
      onChange: (value) => updateQueryParams({ status: value }),
      key: "status",
      setValue: (value) => updateQueryParams({ status: value }),
    },
  ];

  const deleteFunction = () => {
    setLoading(true);
    deleteTask({ id: selected.length > 0 ? selected : [id] })
      .then((d) => {
        afterFunction(cancelDelete, d);
      })
      .catch((e) => console.log(e))
      .finally(() => isMounted.current && setLoading(false));
  };

  const handleSortingFunction = (sortingKey, direction) => {
    updateQueryParams({
      orderBy: sortingKey,
      orderDirection: direction,
    });
  };

  const onChangeViewOptions = (value) =>
    changeViewOptions(taskHeader, setViewOptions, setHeader, value);

  const duplicate = () => {
    duplicatetasks(id).then((d) => {
      afterFunction(canceldubs, d);
    });
  };

  const onChangeSearch = (value) => {
    setSearch(value);
    updateQueryParams({
      search: value,
      orderBy: "identifier",
      orderDirection: "asc",
    });
  };

  const onChangePage = (pageNo) => {
    updateQueryParams({ page: pageNo });
  };

  const onChangeRowsPerPage = (numberOfRows) => {
    setRowsPerPage(numberOfRows);
    updateQueryParams({ limits: numberOfRows });
  };

  const controller = useRef(null);
  const location = useLocation();

  // Effect for handling URL changes and initial setup
  useEffect(() => {
    if (isFirstRender.current) isFirstRender.current = false;
    isMounted.current = true;

    // Create a new abort controller for this effect
    controller.current = new AbortController();

    // Handle collection_id from URL
    if (location.search.slice(0, 4) === "?id=") {
      const collectionId = location.search.slice(4);
      updateQueryParams({ collection_id: collectionId });
    } else {
      // Initial data fetch when no collection_id in URL
      setSelected([]);
      setSelecting([]);
      setLoading(true);

      const queryString = buildQueryString(queryParams);
      enhancedTasks(queryString, controller.current.signal).then((res) => {
        const formattedData = res.data.map((obj) => ({
          ...obj,
          title: obj?.task_contents[0]?.task_title,
        }));
        res.data = formattedData;
        setTaskTable(res);
        setSortableColumns(res?.sortable_columns);
        setLoading(false);
      });
    }

    return () => {
      if (controller.current) {
        controller.current.abort();
      }
      isMounted.current = false;
    };
  }, [location.search]);

  // Effect for data fetching
  useEffect(() => {
    if (controller.current && !isFirstRender.current) {
      setSelected([]);
      setSelecting([]);
      setLoading(true);

      const queryString = buildQueryString(queryParams);
      enhancedTasks(queryString, controller.current.signal).then((res) => {
        const formattedData = res.data.map((obj) => ({
          ...obj,
          title: obj?.task_contents[0]?.task_title,
        }));
        res.data = formattedData;
        setTaskTable(res);
        setSortableColumns(res?.sortable_columns);
        setLoading(false);
      });
    }
  }, [queryParams]);

  const onClickAddTaskToCompetitionAndCollection = () => {
    return selected.length
      ? setOnAddTask(true)
      : showWarningSwal("Please select a task to add to collection");
  };
  const onClickMassAssignTaskPermissions = () => {
    return selected.length
      ? setOnAssignTaskPermission(true)
      : showWarningSwal("Please select a task to assign permissions for");
  };
  const onClickMassDelete = () => {
    return selected.length
      ? setOnDelete(true)
      : showWarningSwal("Please select at least one task to mass delete");
  };

  return (
    <Box className="wrapperBox">
      <LoadingBackdrop loading={loading} />
      <Collapse in={viewing}>
        <ViewOption
          onChangeRowsPerPage={onChangeRowsPerPage}
          viewOptions={viewOptions}
          rowsPerPage={rowsPerPage}
          onChangeViewOptions={onChangeViewOptions}
        />
      </Collapse>
      <Collapse in={filtering}>
        <FilterWrapper filters={filters} adjustEndpoint={adjustEndpoint} />
      </Collapse>
      <Grid
        className="firstRowContainer"
        container
        justifyContent="space-between"
      >
        <div className="dashboardAndSelfBtnDiv">
          <ReusableButton
            text="Dashboard"
            fontSize={14}
            bgColor="#F16774"
            height={36}
            width={125}
            br={18}
            to="/dashboard"
            iconType="home"
          />
          <ChevronRightIcon />
          <ReusableButton
            text="Tasks"
            fontSize={14}
            bgColor="#F16774"
            height={36}
            br={18}
          />
        </div>
        <div className="viewAndFilterBtnDiv">
          <ViewAndFilterButton
            text="View Options"
            state={viewing}
            fontSize={14}
            height={42}
            onClick={handleView}
            marginRight={10}
          />
          <ViewAndFilterButton
            text="Filter"
            state={filtering}
            fontSize={14}
            height={42}
            onClick={handleFilter}
          />
        </div>
      </Grid>
      <Grid className="tableContainer" container>
        <NunitoText
          value="Tasks"
          fontSize={40}
          fontWeight={700}
          italic
          color="#144A94"
        />
        <Grid
          className="searchAndBtnContainer"
          container
          alignItems="center"
          justifyContent="space-between"
        >
          <ReusableTextField
            type="search"
            width={500}
            height={60}
            bgColor="#F2F2F2"
            placeholder="Search using keyword"
            state={search}
            setState={onChangeSearch}
            onBlur
          />
          <div className="endBtnDiv">
            <ReusableButton
              text="Add Task"
              fontSize={15}
              bgColor="#5E75C3"
              height={46}
              marginRight={20}
              to="/addtask"
              iconType="add"
            />
            <ReusableButton
              text="Mass Delete"
              fontSize={15}
              bgColor="#E83042"
              height={46}
              marginRight={20}
              onClick={() => onClickMassDelete()}
              iconType="delete"
            />
          </div>
        </Grid>
        <NunitoText
          value='Search only in "Task Identifier" and "Task Title" column'
          fontSize={20}
          fontWeight={400}
          italic
          color="#144A94"
        />
        {loadingTable && <Loader height={600} />}
        {!loadingTable &&
          taskTable &&
          makeSureIsArray(taskTable.data).length && (
            <HeavyTable
              handleSortingFunction={handleSortingFunction}
              sortableKeys={sortAbleColumns}
              headers={header}
              list={taskTable}
              title="task"
              rowsPerPage={rowsPerPage}
              setOnDups={setOnDups}
              setOnDelete={setOnDelete}
              onChangePage={onChangePage}
              fixed={["identifier", "title"]}
              selecting={selecting}
              setSelecting={setSelecting}
              selected={selected}
              setSelected={setSelected}
              setId={setId}
            />
          )}
        {!loadingTable &&
          taskTable &&
          !makeSureIsArray(taskTable.data).length && <NoData height={600} />}
      </Grid>
      <Modal open={onDelete} onClose={() => cancelDelete()}>
        <>
          {Boolean(taskTable) && (
            <DeleteModal
              table={taskTable}
              id={id}
              selected={selected}
              deleteFunction={deleteFunction}
              cancelDelete={cancelDelete}
            />
          )}
        </>
      </Modal>
      <Modal open={onAddTask} onClose={() => cancelAddTask()}>
        <>
          {Boolean(taskTable) && (
            <AddTaskToCompetitionAndCollectionModal
              afterAddTask={() => {}}
              tasks={taskTable.data}
              selected={selected}
              setSelected={setSelected}
              cancelAddTask={cancelAddTask}
            />
          )}
        </>
      </Modal>
      <Modal
        open={onAssignTaskPermission}
        onClose={() => cancelAssignTaskPermission()}
      >
        <div className="popUpModal horizontalScrollable">
          <h1>Placeholder modal for assigning task permissions</h1>
        </div>
      </Modal>
      <Modal open={onDup} onClose={() => canceldubs()}>
        <>
          {Boolean(taskTable) && (
            <DuplicateTask
              canceldub={canceldubs}
              id={id}
              duplicate={duplicate}
              table={taskTable}
            />
          )}
        </>
      </Modal>
    </Box>
  );
}
